<template>
  <div
    class="academic-record-item border p-2"
    data-testid="academic-record-item">
    <div class="d-flex justify-content-between align-items-center">
      <span class="mr-2 fs-m">{{ academicRecord.gradeCode | gradeCode }}</span>
      <router-link
        v-if="canEdit"
        :to="`/members/${userId}/profile/academic_records/${academicRecord.id}`"
        class="text-decoration-none">
        <IconButton
          class="ml-2"
          width="24"
          height="24"
          icon-size="18"
          icon="edit" />
      </router-link>
      <span class="mr-2 fs-s">更新日時 {{ academicRecord.latestUpdateAt | prettyDate }}</span>
      <CollapseButton
        :open="isCollapseOpen"
        @click="toggleCollapse" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <AcademicRecordDisplay
        v-if="academicRecordDetail"
        :academic-record="academicRecordDetail" />
    </b-collapse>
  </div>
</template>

<script>
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import IconButton from '@/components/parts/IconButton.vue'
import AcademicRecordDisplay from '@/components/view/profile/academic_records/AcademicRecordDisplay.vue'
export default {
  components: {
    CollapseButton,
    IconButton,
    AcademicRecordDisplay,
  },
  props: {
    academicRecord: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isCollapseOpen: false,
      academicRecordDetail: null,
    }
  },
  created() {
    this.fetchAcademicRecordDetail()
  },
  methods: {
    toggleCollapse() {
      this.isCollapseOpen = !this.isCollapseOpen
      if (this.isCollapseOpen) {
        this.fetchAcademicRecordDetail()
      }
    },
    fetchAcademicRecordDetail() {
      this.$axios.get(`/profiles/academic-semesters/${this.academicRecord.id}/`).then((res) => {
        this.academicRecordDetail = res.data
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;

  .chart-labels-table-container {
    width: 600px;
    padding-left: 8px;
  }
}

</style>